// extracted by mini-css-extract-plugin
export default {"root":"SubscriptionManagment_root__007hh"};